import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/Notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { CompanyInfoVungTrong } from 'src/app/shared/CompanyInfoVungTrong.model';
import { CompanyInfoVungTrongService } from 'src/app/shared/CompanyInfoVungTrong.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';
//import { CoSoCompanyInfoVungTrongViewComponent } from '../co-so-CompanyInfoVungTrong-view/co-so-CompanyInfoVungTrong-view.component';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { CompanyInfoVungTrongDetailComponent } from '../company-info-vung-trong-detail/company-info-vung-trong-detail.component';
import { CompanyInfoDetailComponent } from '../company-info-detail/company-info-detail.component';
import { CompanyInfoDonViDongGoiDetailComponent } from '../company-info-don-vi-dong-goi-detail/company-info-don-vi-dong-goi-detail.component';
import { TinhTrangHoSoService } from 'src/app/shared/TinhTrangHoSo.service';
import { TinhTrangTDKTGSService } from 'src/app/shared/TinhTrangTDKTGS.service';


@Component({
  selector: 'app-company-info-don-vi-dong-goi',
  templateUrl: './company-info-don-vi-dong-goi.component.html',
  styleUrls: ['./company-info-don-vi-dong-goi.component.css']
})
export class CompanyInfoDonViDongGoiComponent implements OnInit {

  @ViewChild('CompanyInfoVungTrongSort') CompanyInfoVungTrongSort: MatSort;
  @ViewChild('CompanyInfoVungTrongPaginator') CompanyInfoVungTrongPaginator: MatPaginator;

  DisplayColumns: string[] = ['CanhBao', ...this.CompanyInfoVungTrongService.DisplayColumns002];

  constructor(
    private dialog: MatDialog,
    public NotificationService: NotificationService,

    public CompanyInfoVungTrongService: CompanyInfoVungTrongService,

    public CompanyInfoService: CompanyInfoService,

    public ThanhVienService: ThanhVienService,
    public TinhTrangHoSoService: TinhTrangHoSoService,
    public TinhTrangTDKTGSService: TinhTrangTDKTGSService,
  ) { }

  ngOnInit(): void {
    this.ThanhVienGetLogin();
    this.DisplayColumns = ['CanhBao', ...this.CompanyInfoVungTrongService.DisplayColumns002];
    this.TinhTrangHoSoSearch();
    this.TinhTrangTDKTGSSearch();
    this.CompanyInfoVungTrongSearch();
  }
  ThanhVienGetLogin() {
    this.ThanhVienService.GetLogin();
  }
  isDateGreaterThanCurrentPlusThreeDays(dateToCheck: Date, dateWarning: number): boolean {
    if(dateToCheck==null) return false;
    const currentDate = new Date();
    const datePlusThreeDays = new Date(currentDate);
    datePlusThreeDays.setDate(currentDate.getDate() - dateWarning);
    return new Date(dateToCheck) < datePlusThreeDays;
  }
  CompanyInfoVungTrongSearch() {
       
    this.CompanyInfoVungTrongService.IsShowLoading = true;        
    this.CompanyInfoVungTrongService.BaseParameter.Active = true;    
    this.CompanyInfoVungTrongService.GetByActiveToListAsync().subscribe(
      res => {
        const now = new Date();
        this.CompanyInfoVungTrongService.List = (res as CompanyInfoVungTrong[])
          .sort((a, b) => (a.NgayGhiNhan < b.NgayGhiNhan ? 1 : -1))
          .filter(r=>r.Active && r.TypePlan == 2)
          .map(item => {
            const ngayGhiNhan = item.NgayGhiNhan ? new Date(item.NgayGhiNhan) : null;
            const lastUpdated = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
            const statusName = (item.DanhMucATTPTinhTrangName || '').trim().toLowerCase();
            const isGuiCoQuan = statusName === 'đã gửi cơ quan quản lý';
            const isBanNhap = statusName === 'bản nháp' || statusName === 'ban nhap';
            if(isBanNhap){
              return {...item, IsWarning:false};
            }
            const quaHanGui = (ngayGhiNhan)
              ? this.isDateGreaterThanCurrentPlusThreeDays(ngayGhiNhan, 3) && isGuiCoQuan
              : false;

            const chuaBuoc3 = !item.NgayThongBaoLaiKiemTraGiamSat && !item.TinhTrangTDKTGSID;
            const quaHanBuoc3 = lastUpdated
              ? (new Date(lastUpdated) < new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000)) && chuaBuoc3
              : false;

            return {
              ...item,
              IsWarning: quaHanGui || quaHanBuoc3
            };
          });
        this.CompanyInfoVungTrongService.DataSource = new MatTableDataSource(this.CompanyInfoVungTrongService.List);
        this.CompanyInfoVungTrongService.DataSource.sort = this.CompanyInfoVungTrongSort;
        this.CompanyInfoVungTrongService.DataSource.paginator = this.CompanyInfoVungTrongPaginator;        
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      },
      err => {        
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      }
    );
  }
  TinhTrangHoSoSearch() {
    this.TinhTrangHoSoService.ComponentGetAllToListAsync();
  }
  TinhTrangTDKTGSSearch() {
    this.TinhTrangTDKTGSService.ComponentGetAllToListAsync();
  }
  FindTinhTrangHoSoNameByID(idInput:number){
    if(idInput == null || idInput == undefined) return "";
    return this.TinhTrangHoSoService.List?.find(l=>l.ID == idInput)?.Name || "";
  }
  FindTinhTrangTDKTGSNameByID(idInput:number){
    if(idInput == null || idInput == undefined) return "";
    return this.TinhTrangTDKTGSService.List?.find(l=>l.ID == idInput)?.Name || "";
  }
  CompanyInfoVungTrongDelete(element: CompanyInfoVungTrong) {
    this.CompanyInfoVungTrongService.IsShowLoading = true;
    element.Active = false;
    this.CompanyInfoVungTrongService.FormData = element;
    this.CompanyInfoVungTrongService.FormData.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    this.CompanyInfoVungTrongService.SaveAsync().subscribe(
      res => {
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoVungTrongSearch();
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      }
    );
  }

  CompanyInfoVungTrongAdd(ID: number) {
    this.CompanyInfoVungTrongService.BaseParameter.ID = ID;    
    this.CompanyInfoVungTrongService.GetByIDAsync().subscribe(
      res => {
        if(ID==0){
          this.CompanyInfoVungTrongService.FormData = res as CompanyInfoVungTrong;
        }else{
          this.CompanyInfoVungTrongService.FormData = {}
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID, IsStaff: true, CompanyInfoVungTrongDetail: res };
        const dialog = this.dialog.open(CompanyInfoDonViDongGoiDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {
          this.CompanyInfoVungTrongSearch();
        });
      },
      err => {
      }
    );
  }  
  CompanyInfoAdd(ID: number) {
    this.CompanyInfoService.BaseParameter.ID = ID;    
    this.CompanyInfoService.GetByIDAsync().subscribe(
      res => {
        this.CompanyInfoService.FormData = res as CompanyInfo;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID };
        const dialog = this.dialog.open(CompanyInfoDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {          
        });
      },
      err => {
      }
    );
  }  
}

